import React from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

const Section = ({ title, description, photos }) => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <h2>{title}</h2>
          <hr />
          {documentToReactComponents(description)}
        </div>
        {/* <p>We're going to present you {photos} photos</p> */}
      </div>
    </div>
  );
};

export default Section;
